import { render, staticRenderFns } from "./GroupAccessItem.vue?vue&type=template&id=7e722fe8&scoped=true"
import script from "./GroupAccessItem.vue?vue&type=script&lang=js"
export * from "./GroupAccessItem.vue?vue&type=script&lang=js"
import style0 from "./GroupAccessItem.vue?vue&type=style&index=0&id=7e722fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e722fe8",
  null
  
)

export default component.exports